import { imageUrlLoads } from '@/helpers/images/imageUrlLoads';
import IImage from '@/interfaces/IImage';

const processed = new Set<string>();

/**
 * Attempts to validate an image source, and falls back if `_big` version fails.
 * Mutates the image object directly (must be reactive).
 */
export function checkAndFixImageFallback(img: IImage): void {
    const originalSrc = img.src;

    if (!originalSrc || !originalSrc.includes('_big') || processed.has(originalSrc)) {
        return;
    }

    processed.add(originalSrc);

    imageUrlLoads(originalSrc, (result) => {
        if (result) return;

        const fallbackSrc = originalSrc.replace('_big', '');
        imageUrlLoads(fallbackSrc, (fallbackResult) => {
            if (fallbackResult) {
                img.src = fallbackSrc;
                // Optionally log or track fallback
                // console.info(`Fallback applied: ${originalSrc} -> ${fallbackSrc}`);
            }
        });
    });
}
